<template>
  <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 page">
    <div class="page-help-corner">
      <help-icon help-id="trendlabs" title="Help for Trend Labs" />
    </div>

    <p class="mb-md-o mb-0">
      <small class="">
        <strong>
          Toggle <input type="checkbox" class="mr-1 mr-md-1" :checked="checked" @click="checked=!checked"/>to {{ graphOrUngraphMessage }}
        </strong>
      </small>
    </p>
    <!-- <vital-signs></vital-signs> -->
      
    <watch-list :newestProcedure="procCcd"></watch-list>

    <watch-graph></watch-graph>
 
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import WatchGraph from "./_partials/watch/Graph";
  import WatchList from "./_partials/watch/WatchList";
  import VitalSigns from "./_partials/watch/VitalSigns";
  import { 
    requestVitalSignsCodes
  } from '@/api/sessionApi';
  import {
    requestExternalMeasures,
    requestContinuousGlucose
  } from '@/api/dataApi';
  import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import { h } from 'vue';
import HelpIcon from '@/components/help/HelpIcon.vue';

  export default {
    name: "watch-page",
    props: {
      procCcd: {
        type: Number,
        default: 0
      }
    },
    components: {
      'watch-graph': WatchGraph, 
      'watch-list': WatchList,
      'vital-signs': VitalSigns,
      HelpIcon,
    },
    data() {
      return {
        checked: false
      }
    },
    computed: {
      graphOrUngraphMessage() {
        return this.checked?'ungraph':'graph'
      },
      ...mapGetters('login/watch', {
        measuresWatching: 'getMeasuresWatching',
        proceduresWatching: 'getProceduresWatching',
        checkedMeasures: 'getCheckedMeasures',
        vitalCcds: 'getVitalSignCodes',
        areExternalMeasuresLoaded: 'areExternalMeasuresLoaded'
      }),
      hasItemInWatchList() {
        return (this.measuresWatching && Object.keys(this.measuresWatching).length > 0)
        || (this.proceduresWatching && Object.keys(this.proceduresWatching).length > 0);
      }
    },
    methods: {
      ...mapActions('login/watch', [
        'setVitalSignCodes',
        'setExternalMeasuresLoaded'
      ]),
      ...mapActions('login', [
        'addMeasures'
      ])
    },
    mounted() {
      if (!this.vitalCcds || this.vitalCcds.length < 1) {
        requestVitalSignsCodes()
        .then((vitalSignCodes) => {
          this.setVitalSignCodes(vitalSignCodes);
        })
        .catch((err) => {
          console.error(err);
        });
      }
      // console.log(this.areExternalMeasuresLoaded)
      if (!this.areExternalMeasuresLoaded) {
  //       requestContinuousGlucose()
	// .then((item) => {
	// 	console.dir(item);
	// });
        let loader = this.$loading.show({},{
            after: () => h('div',{},'Loading data...')
        });
        requestExternalMeasures()
        .then(({externalMeasures,externalMeasCcdMeasIds,externalMeasCcds,patientId}) => {
          // `patientId`: whose readings these are, so a late answer for a
          // chart no longer in view is dropped (store/modules/measuresChart.js).
          this.addMeasures({externalMeasures,externalMeasCcdMeasIds,externalMeasCcds,patientId});
          this.setExternalMeasuresLoaded(true);
        })
        .then(() => {
          loader.hide()
          loader = null
        })
        .catch((err) => {
          console.dir(err);
          alert(err);
        });
      }
    },
    beforeDestroy() {
      delete this.graphOrUngraphMessage;
      delete this.hasItemInWatchList;
    }
  }
</script>

<style scoped lang="scss">

  .page {
    margin-bottom: 4.0rem;
  }

  .page-help-corner {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.35rem;
  }

  .card-header {
    padding: 0.2rem;
    background-color: #fff;

    a {
      width: 100%;
      text-align: left;
    }
 }
  .card-body {
    padding: 0;
    font-size: 0.95rem;
  }

  .btn--remove {
    background-color: transparent;
    margin: 0;
    padding: 0;
    color: #ff4444;

    &:hover {
      color: #cc0000;
    }
  }

</style>
